export enum Tab {
    LIST = "list",
    WEEK = "week",
    DAY = "day",
}
